import { v4 as uuidv4 } from 'uuid';

/** Generates a new UUID v4 to be used as X-Correlation-Id per user action. */
export function newCorrelationId(): string {
  return uuidv4();
}
